import { PinnedProducts } from 'pages/ProductListing/PinnedProducts';
import { CategoryTitle } from 'pages/StoryBlok/CategoryTitle';
import { ClothesFinder } from 'pages/StoryBlok/ClothesFinder';
import { ClothesFinderWizard } from 'pages/StoryBlok/ClothesFinder/Wizard';
import { ProductGuide } from 'pages/StoryBlok/ProductGuide';
import { Promo18Check } from 'pages/StoryBlok/Promo18Check';
import { AdventCalendarBlock } from './AdventCalendarBlock';
import { AllBrandsBlock } from './AllBrands';
import { BannerCampaign } from './BannerCampaign';
import { BannerHero } from './BannerHero';
import { BraFitter } from './BraFitter';
import { BrandCategoryBanner } from './BrandCategoryBanner';
import { ButtonCTA } from './ButtonCTA';
import { CategoryChips } from './CategoryChips';
import { ContentAccordion } from './ContentAccordion';
import { ContentBlock } from './ContentBlock';
import { DailyDeals } from './DailyDeals';
import { GiftFinderWizard } from './Finders/FinderWizard';
import { FinderMainBanner } from './Finders/MainBanner';
import { FinderResultHero } from './Finders/ResultHero';
import { GiftCardBlockContainer } from './GiftCardBlock';
import { GiftFinder } from './GiftFinder';
import { Iframe } from './Iframe';
import { LandingCategoryBanner } from './LandingCategoryBanner';
import { LandingHero } from './LandingHero';
import { LandingIconsList } from './LandingIconsList';
import { LandingImageSlider } from './LandingImageSlider';
import { LandingImageText } from './LandingImageText';
import { LandingImageTextTile } from './LandingImageTextTile';
import { LandingProductDetails } from './LandingProductDetails';
import { LandingProductSlider } from './LandingProductSlider';
import { LandingReviewBlock } from './LandingReviewBlock';
import { LandingTextBlock } from './LandingTextBlock';
import { ListicleBlock } from './ListicleBlock';
import { MagazineTeaser, MagazineTeasersList } from './MagazineTeasers';
import { MarksBlock } from './MarksBlock';
import { NewsletterBlock } from './NewsletterBlock';
import { Page } from './Page';
import { ProductComparisonBlock } from './ProductComparisonBlock';
import { ProductGrid } from './ProductGrid';
import { ProductManualGridContainer } from './ProductManualGrid';
import { PromoBanner } from './PromoBanner';
import { RecommendationBlock } from './RecommendationBlock';
import { ReturnOrderButton } from './ReturnOrderButton';
import { RichText } from './RichText';
import { SeoAccordion } from './SeoAccordion';
import { SeoBlock } from './SeoBlock';
import { SymbolInCircle } from './SymbolInCircle';
import { TextImageBlock } from './TextImageBlock';
import { ThemeHeroBanner } from './ThemeHeroBanner';
import { TileBannerContainer } from './TileBanner';
import {
  StoryblokBannerTrust,
  StoryblokBannersTrustAllContainer,
} from './TrustBanner';
import { YoutubeVideo } from './YoutubeVideo';

// after remove demo components, move to src/client/modules/stroyblok
export const components = {
  page: Page,
  magazineTeasers: MagazineTeasersList,
  'magazine-teaser': MagazineTeaser,
  categoryTitle: CategoryTitle,
  seoAccordeon: SeoAccordion,
  categoryChips: CategoryChips,
  'banner-promo': PromoBanner,
  productGrid: ProductGrid,
  pinnedProducts: PinnedProducts,
  productManualGrid: ProductManualGridContainer,
  ContentPage: ContentBlock,
  ListicleBlock,
  richText: RichText,
  'banner-trust': StoryblokBannerTrust,
  'banners-trust-all': StoryblokBannersTrustAllContainer,
  'youtube-link': YoutubeVideo,
  'symbol-in-circle': SymbolInCircle,
  'banner-hero': BannerHero,
  contentAccordion: ContentAccordion,
  buttonCTA: ButtonCTA,
  richTextWithImage: TextImageBlock,
  'banner-campaign': BannerCampaign,
  'banner-tile': TileBannerContainer,
  brandCategoryBanner: BrandCategoryBanner,
  'banner-theme-hero': ThemeHeroBanner,
  landingCategoryBanner: LandingCategoryBanner,
  landingImageTextTile: LandingImageTextTile,
  landingImageSlider: LandingImageSlider,
  landingTextBlock: LandingTextBlock,
  landingReviewBlock: LandingReviewBlock,
  landingProductSlider: LandingProductSlider,
  landingIconsList: LandingIconsList,
  landingImageText: LandingImageText,
  promo18Check: Promo18Check,
  iframe: Iframe,
  'marks-with-image': MarksBlock,
  landingProductDetails: LandingProductDetails,
  news_letter: NewsletterBlock,
  allBrandsBlock: AllBrandsBlock,
  giftCardBlock: GiftCardBlockContainer,
  dailyDeals: DailyDeals,
  recommendationBlock: RecommendationBlock,
  clothesFinderContent: ClothesFinder,
  clothesFinderWizard: ClothesFinderWizard,
  giftFinderContent: GiftFinder,
  finderResultHero: FinderResultHero,
  giftFinderWizard: GiftFinderWizard,
  finderMainBanner: FinderMainBanner,
  landingHero: LandingHero,
  seoBlock: SeoBlock,
  productGuide: ProductGuide,
  braFitter: BraFitter,
  adventCalendarBlock: AdventCalendarBlock,
  productComparisonBlock: ProductComparisonBlock,
  returnOrderButton: ReturnOrderButton,
};
